import React, { useRef } from 'react';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { getAssetUrl, getRawAssetUrl } from '../../Api';
import * as S from './style';

// Rail horizontal de cartões com chapéu, título e setas: o "Fique por dentro"
// da Home, usado também em "Outros álbuns" da galeria.
//
// Cada seta avança os cartões que cabem inteiros na faixa (2 no desktop, 1 no
// celular), em múltiplos de cartão + gap, para o próximo parar alinhado à
// esquerda.
export const Vitrine = ({ chapeu, titulo, id, rotuloAnterior, rotuloProximo, children }) => {
  const trilho = useRef(null);

  const rolar = (sentido) => {
    const t = trilho.current;
    const cartao = t?.firstElementChild;
    if (!cartao) return;
    const gap = parseFloat(getComputedStyle(t).columnGap) || 24;
    const passo = cartao.offsetWidth + gap;
    const cabem = Math.max(1, Math.floor(t.clientWidth / passo));
    t.scrollBy({ left: passo * cabem * sentido, behavior: 'smooth' });
  };

  return (
    <>
      <S.Cabeca>
        <div>
          {chapeu && <S.Chapeu>{chapeu}</S.Chapeu>}
          {titulo && <h2 id={id}>{titulo}</h2>}
        </div>
        <S.Setas>
          <S.Seta type="button" onClick={() => rolar(-1)} aria-label={rotuloAnterior}>
            <ChevronLeft size={20} />
          </S.Seta>
          <S.Seta type="button" onClick={() => rolar(1)} aria-label={rotuloProximo}>
            <ChevronRight size={20} />
          </S.Seta>
        </S.Setas>
      </S.Cabeca>
      <S.Trilho ref={trilho}>{children}</S.Trilho>
    </>
  );
};

// Um cartão do rail: imagem do Squidex no topo, etiqueta, título, texto e um
// link que leva a uma rota do site.
export const CartaoVitrine = ({ imagem, etiqueta, titulo, texto, acao, para }) => (
  <S.Cartao>
    {imagem && (
      <S.Imagem
        src={getAssetUrl(imagem, { width: 760, quality: 85, format: 'webp' })}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = getRawAssetUrl(imagem);
        }}
        onLoad={(e) => {
          const img = e.currentTarget;
          if (img.naturalHeight > img.naturalWidth) img.dataset.retrato = '';
        }}
        alt=""
        loading="lazy"
        decoding="async"
      />
    )}
    {etiqueta && <S.Etiqueta>{etiqueta}</S.Etiqueta>}
    <h3 title={titulo}>{titulo}</h3>
    {texto && <p>{texto}</p>}
    {acao && para && (
      <S.Acao to={para}>
        <span>{acao}</span>
        <ArrowRight size={16} className="seta" aria-hidden="true" />
      </S.Acao>
    )}
  </S.Cartao>
);
